<template>
	<div v-if="!pageLoading" class="w-100 quotation-line-items overflow-y custom-table-height mt-3">
		<div class="d-flex justify-end align-center">
			<v-btn
				@click="saveEquipment(line_items)"
				class="white--text"
				depressed
				color="blue darken-4"
				tile
				:disabled="projectStatus == 3"
			>
				Save
			</v-btn>
		</div>

		<table width="100%" style="table-layout: fixed" class="mt-2">
			<thead>
				<tr>
					<th class="pa-2 simple-table-th" width="40"></th>
					<th class="pa-2 simple-table-th text-center" width="40">#</th>
					<th class="pa-2 simple-table-th">Equipment</th>
					<th class="pa-2 simple-table-th">Description</th>
					<th class="pa-2 simple-table-th">Quantity</th>
					<th class="pa-2 simple-table-th text-right" width="40"></th>
				</tr>
			</thead>
			<Draggable
				tag="tbody"
				v-model="line_items"
				class="draggable-group"
				handle=".draggable-drag-icon"
				v-clickoutside="outsideClicked"
				v-on:change="updateItemOrder($event)"
			>
				<tr v-for="(row, index) in line_items" :key="index" class="">
					<td class="py-1 px-2">
						<v-icon class="draggable-drag-icon cursor-move" color="blue darken-4">mdi-drag</v-icon>
					</td>
					<td class="py-1 px-2 text-center">{{ index + 1 }}</td>
					<td
						class="py-1 px-2"
						@click="editRow($event, index)"
						:class="row.isEditable ? 'px-2' : 'px-3'"
					>
						<AutoCompleteInput
							hide-details
							v-if="row.isEditable"
							:items.sync="equipmentList"
							item-text="text"
							item-value="id"
							class="mt-0"
							placeholder="Equipment"
							v-model="row.equipment"
						></AutoCompleteInput>
						<template v-else>{{ getEquipmentName(row.equipment) }}</template>
					</td>
					<td
						style="max-width: 300px"
						class="py-1 px-2 text-truncate"
						@click="editRow($event, index)"
						:class="row.isEditable ? 'px-2' : 'px-3'"
					>
						<TextInput
							v-if="row.isEditable"
							hide-details
							:disabled="pageLoading"
							:loading="pageLoading"
							v-model="row.equipment_description"
							class="mt-0"
						></TextInput>
						<template v-else>{{ row.equipment_description }}</template>
					</td>
					<td
						class="py-1 px-2"
						@click="editRow($event, index)"
						:class="row.isEditable ? 'px-2' : 'px-3'"
					>
						<TextInput
							v-if="row.isEditable"
							hide-details
							:disabled="pageLoading"
							type="number"
							:loading="pageLoading"
							v-model="row.items_quantity"
							class="mt-0"
						></TextInput>
						<template v-else>{{ row.items_quantity }}</template>
					</td>

					<td class="py-1 px-2 text-right">
						<v-icon
							title="Equipment"
							color="red"
							:disabled="line_items.length == 1 ? true : false"
							class="cursor-pointer"
							@click="deleteLineItems(index, row.id)"
							>mdi-delete-outline</v-icon
						>
					</td>
				</tr>
				<tr>
					<td class="pa-2 borer-none" colspan="5">
						<v-btn @click="addLineItems()" class="white--text" depressed color="blue darken-4" tile>
							<v-icon left>mdi-plus</v-icon>
							Add Equipment
						</v-btn>
					</td>
				</tr>
			</Draggable>
			<!-- </tbody> -->
		</table>

		<Dialog
			:dialog="deleteConfirmationDialog"
			v-on:close="deleteConfirmationDialog = false"
			v-if="deleteConfirmationDialog"
			:dialog-width="500"
		>
			<template v-slot:title> Are you sure? </template>
			<template v-slot:body>
				<v-row>
					<v-col md="12" class="py-0">
						<p class="mt-0" style="line-height: 18px">
							Are you sure want to delete line item?
							<br />
							Line item can not be recovered once deleted?
						</p>
					</v-col>
				</v-row>
			</template>
			<template v-slot:action>
				<v-btn
					:disabled="deleteConfirmationLoading"
					depressed
					tile
					@click="deleteConfirmationDialog = false"
				>
					NO</v-btn
				>
				<v-btn
					:disabled="deleteConfirmationLoading"
					:loading="deleteConfirmationLoading"
					class="white--text"
					depressed
					color="blue darken-4"
					tile
					@click="yesDeleteLineItem()"
				>
					YES
				</v-btn>
			</template>
		</Dialog>
	</div>
</template>
<script>
import TextInput from "@/view/components/TextInput";
import Dialog from "@/view/components/Dialog";
import AutoCompleteInput from "@/view/components/AutoCompleteInput";
import Draggable from "vuedraggable";
import { GetAllProduct } from "@/core/lib/common.lib";
import { DeletePOLineItem } from "@/core/lib/purchase-order.lib";
import { filter, find, map, cloneDeep } from "lodash";
import "@/core/event-bus/click-outside";
import { GetEquipmentList } from "@/core/lib/project-transfer.lib.js";
import { GetProjectBudgetLineItems, createEquipment } from "@/core/lib/project-transfer.lib.js";
import { SET_ERROR, SET_MESSAGE } from "@/core/services/store/common.module";
export default {
	name: "po-line-items",
	model: {
		prop: "value",
		event: "input",
	},
	props: {
		projectStatus: {
			type: Number,
			default: 1,
		},
	},
	data() {
		return {
			pageLoading: false,
			deleteConfirmationDialog: false,
			deleteConfirmationLoading: false,
			createProductDialog: false,
			deleteId: null,
			deleteIndex: -1,
			isOutside: true,
			line_items: [
				{
					isEditable: false,
					equipment: null,
					description: null,
					quantity: 1,
					order: 1,
					items_quantity: 1,
					items_uom: null,
					rate: 0,
					total: 0,
					budget_type: 0,
				},
			],
			taxList: [8],
			tax_value: 8,
			taxable_amount: 0,
			tax_amount: 0,
			discount_value: 0,
			discount_amount: 0,
			discount_value_type: 1,
			discount_type: 1,
			adjustment: 0,
			adjustment_amount: 0,
			sub_total: 0,
			total: 0,
			discountTypeList: [
				{ text: "$", value: 1 },
				{ text: "%", value: 2 },
			],
			equipmentList: [],
			productList: [
				{
					id: 1,
					name: "Chair",
					unit_price: 0,
					status: 1,
					unit: null,
					selling_cost: 12,
					discount_price: 0,
					charges: 0,
					product_type: "inventory",
					barcode: "P001",
					uuid: "",
					description: null,
					pid: 1,
					uprice: 0,
					sprice: 12,
					dprice: 0,
					suppliers: [{ id: 2, price: 140 }],
					uom: 0,
					value: 1,
					text: "P001 - Chair",
					seller_id: 2,
					seller_price: 140,
				},
			],
			allProductList: [],
		};
	},

	computed: {
		product_list: () => {
			return function (id) {
				let _equipmentList = cloneDeep(this.equipmentList);
				const newArray = filter(_equipmentList, (row) => {
					if (row.value != id) {
						if (!find(this.line_items, (inner_row) => inner_row.product == row.id)) {
							return row;
						}
					} else {
						return row;
					}
				});
				return newArray;
			};
		},
	},

	methods: {
		outsideClicked() {
			if (!this.isOutside) {
				const _line_items = this.line_items.map((row) => {
					return { ...row, isEditable: false };
				});
				this.line_items = _line_items;
				this.isOutside = true;
			}
		},
		changeClicked() {
			this.isOutside = true;
		},

		editRow(event, index) {
			this.isOutside = false;
			const element = event.target;
			const _line_items = this.line_items.map((row) => {
				return { ...row, isEditable: false };
			});
			this.line_items = _line_items;
			this.line_items[index].isEditable = true;
			this.$nextTick(() => {
				const inputarea = element.querySelector("input");
				if (inputarea) {
					inputarea.focus();
					inputarea.select();
				}
			});
			if (element.nodeName == "INPUT") {
				element.select();
			}
			if (this.line_items.length == index + 1) {
				this.addLineItems();
			}
		},
		tabClicked(event, index) {
			if (this.line_items.length == index + 1) {
				this.addLineItems();
			}

			const _line_items = this.line_items.map((row) => {
				return { ...row, isEditable: false };
			});
			this.line_items = _line_items;
			this.line_items[index + 1].isEditable = true;
		},
		async yesDeleteLineItem() {
			try {
				this.deleteConfirmationLoading = true;
				if (this.deleteId) {
					await DeletePOLineItem(this.deleteId);
					this.line_items.splice(this.deleteIndex, 1);
					this.$emit("input", this.line_items);

					this.deleteId = null;
					this.deleteIndex = -1;
				}
			} catch (error) {
				console.log(error);
			} finally {
				this.deleteConfirmationLoading = false;
				this.deleteConfirmationDialog = false;
			}
		},
		async deleteLineItems(index, id) {
			if (id) {
				this.deleteConfirmationDialog = true;
				this.deleteId = id;
				this.deleteIndex = index;
			} else {
				if (this.line_items.length > 1) {
					this.line_items.splice(index, 1);
					this.$emit("input", this.line_items);
				}
				if (id) {
					await DeletePOLineItem(id);
				}
			}
		},
		addLineItems() {
			const _order = this.line_items.length;
			this.line_items.push({
				isEditable: false,
				id: null,
				budget_items_description: null,
				budget_items_uom: "lot",
				budget_items_quantity: 1,
				budget_items_rate: 0,
				budget_items_total: 0,
				uuid: null,
				order: _order + 1,
			});
			this.$emit("input", this.line_items);
		},
		getEquipmentName(id) {
			const product = find(this.equipmentList, (row) => row.value == id);
			if (product) {
				return product.text;
			} else {
				return null;
			}
		},
		getAllProduct() {
			GetAllProduct()
				.then(({ list }) => {
					const _product_data = filter(list, (row) => {
						return row.product_type == "inventory";
					});
					this.allProductList = map(_product_data, (row) => {
						return { ...row, value: row.id, text: `${row.barcode} - ${row.name}` };
					});
				})
				.catch((error) => {
					console.log(error);
				});
		},
		async getLineItem() {
			const data = await GetProjectBudgetLineItems(this.$route.params.uuid, 3);
			this.line_items = data;
			if (!this.line_items.length) {
				const _order = this.line_items.length;
				this.line_items = [
					{
						isEditable: false,
						id: null,
						budget_items_description: null,
						budget_items_uom: "lot",
						budget_items_quantity: 1,
						budget_items_rate: 0,
						budget_items_total: 0,
						uuid: null,
						// product: null,
						// description: null,
						//pendingstatus: false,
						// uom: null,
						// quantity: 1,
						// rate: 0,
						// total: 0,
						order: _order + 1,
					},
				];
			}
		},
		async getEquipmentAllList() {
			try {
				const equipmentList = await GetEquipmentList(this.$route.params?.uuid);

				this.equipmentList = map(equipmentList, (row) => {
					return { ...row, value: row.id, text: `${row.barcode} - ${row.name}` };
				});
				//console.log(this.equipmentList);
			} catch (error) {
				console.log(error);
			}
		},

		async saveEquipment(equipments) {
			const filterLineItem = equipments.filter((equipment) => equipment.equipment);
			const equipmentsLineItem = filterLineItem.map((equipment) => {
				if (equipment.equipment) {
					return {
						uuid: equipment.budget_uuid || null,
						line_item: null,
						item_id: equipment.equipment || 0,
						description: equipment.equipment_description || null,
						quantity: equipment.items_quantity || 0,
						quantity_type: null,
						discount: null,
						rate: 0,
						uom: null,
						tax_value: null,
						tax_amount: null,
						sub_total: 0,
						total: 0,
					};
				}
			});

			if (equipmentsLineItem.length == 0) {
				this.$store.commit(SET_ERROR, [{ model: true, message: "Equipments required" }]);
				return false;
			}

			this.pageLoading = true;
			try {
				await createEquipment(this.$route.params.uuid, 3, equipmentsLineItem);
				await this.getLineItem();
				//console.log(data);
				this.$store.commit(SET_MESSAGE, [
					{ model: true, message: "Success ! Budget Equipements are saved." },
				]);
			} catch (error) {
				//console.log(error);
				this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
			} finally {
				this.pageLoading = false;
			}
		},
	},

	components: {
		Draggable,
		AutoCompleteInput,
		TextInput,
		// AutoCompleteInput,
		Dialog,
	},

	async mounted() {
		await this.getLineItem();
		await this.getEquipmentAllList();
	},
};
</script>

<style scoped>
.quotation-line-items th {
	font-weight: 500;
}

.quotation-line-items th,
.quotation-line-items td:not(.borer-none) {
	border-bottom: 1px solid #c7c7c7;
	border-left: 1px solid #c7c7c7;
	height: 40px;
}

.quotation-line-items th:first-child,
.quotation-line-items td:first-child {
	border-left: none !important;
}
.quotation-line-items {
	max-height: 500px;
	overflow: auto;
}

.quotation-line-items thead {
	position: sticky;
	top: 0;
	bottom: 0;
	z-index: 999999;
	background: #f6f6f6;
}
</style>
